var map = {
	"./g0.svg": "MFUS",
	"./g1.svg": "aVFf",
	"./g10.svg": "84UC",
	"./g11.svg": "ZHke",
	"./g2.svg": "j95f",
	"./g3.svg": "8lia",
	"./g4.svg": "48xA",
	"./g5.svg": "fG8N",
	"./g6.svg": "1N1O",
	"./g7.svg": "h8cX",
	"./g8.svg": "UFtt",
	"./g9.svg": "XH76",
	"./goNext.svg": "KXXf",
	"./goPrev.svg": "G7nl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9PHV";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip ^\.\/g.*\.svg$
// module id = 9PHV
// module chunks = 0